export default __webpack_public_path__ + "static/media/sql.64b3eb63.png";